import { render } from "./TipoPagamento.vue?vue&type=template&id=2fe42d61"
import script from "./TipoPagamento.vue?vue&type=script&lang=js"
export * from "./TipoPagamento.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__